import React from 'react';
import * as d3 from 'd3';
import ExpandableAutoComplete from 'src/components/UI/button/ExpandableAutoComplete';
import { Box } from '@mui/material';

function LocatePerson({ pedref, members, handleClick }) {
  const locate = (upn) => {
    const groups = d3
      .select(pedref.current)
      .selectAll('g')
      .filter(function (d) {
        if (upn === 1) return d?.proBandId;

        if (d && d.upn && Number(d.upn) === upn) {
          return d;
        }
      });

    if (groups?._groups[0]?.length > 0) {
      const target = groups.select('path.te');

      let nodeData = target.datum();

      const nodeX = nodeData.x;
      const nodeY = nodeData.y;

      const svgWidth = 1140;
      const svgHeight = 860;
      const scale = 0.3;

      const targetTranslateX = svgWidth / 1.8 - nodeX * scale;
      const targetTranslateY = svgHeight / 2.2 - nodeY * scale;

      let t = {
        x: targetTranslateX ?? -291,
        y: targetTranslateY ?? -348,
        k: 0.3
      };

      const zoomBehavior = d3.zoom().on('zoom', (event) => {
        d3.select(pedref.current)
          .select('.diagram')
          .attr('transform', event.transform);

        d3.select(pedref.current)
          .select('pattern')
          .attr('patternTransform', event.transform);
      });

      const svg = d3.select(pedref.current).select('svg');

      svg
        .transition()
        .duration(500)
        .call(
          zoomBehavior.transform,
          d3.zoomIdentity.translate(t.x, t.y).scale(t.k)
        );

      handleClick(null, target.datum(), target.node(), null);
    }
  };

  const onChange = (e, option) => {
    e.preventDefault();
    e.stopPropagation();
    if (option?.upn) locate(option.upn);
  };

  const locateMenu = React.useMemo(() => {
    const options = members
      ? members
          .map((member) => {
            if (member.upn)
              return {
                upn: Number(member.upn),
                label: `UPN ${member.upn}  ${
                  member.firstName
                    ? '- ' + member.firstName + ' ' + (member.lastName || '')
                    : ''
                }`
              };
            else if (member.proBandId)
              return {
                upn: 1,
                label: `UPN 1  ${
                  member.firstName
                    ? '- ' + member.firstName + ' ' + (member.lastName || '')
                    : ''
                }`
              };
          })
          .filter((m) => m)
          .sort((a, b) => a.upn - b.upn)
      : [];

    return (
      <>
        <ExpandableAutoComplete options={options} onChange={onChange} />
      </>
    );
  }, [members]);

  return <Box>{locateMenu}</Box>;
}

export default LocatePerson;
